import React, { useState, useRef } from 'react';
import axios from 'axios';
import Typography from '../Typography';
import { TextInputContainer as TextInput } from './components/TextInput'
import ToyotaButton from '../ToyotaButton';
import HtmlText from '../HtmlText';
import Fade from 'react-reveal/Fade';
import { useTranslation } from 'react-i18next';
import { ModalProvider } from 'styled-react-modal';
import { CheckboxInput, CheckIcon, Wrapper, Intro, OptionsHeading, OptionsInstructions, Checkboxes, CtaWrapper } from './index.styled';
import { ConfirmationModal } from './components/ConfirmationModal';
import { MessageArea } from './components/MessageArea';
import { useLocation } from "@reach/router"
import configData from './config.json';

const FadeIn = (props) => <Fade distance="100px" {...props} />;

const CheckboxInputContainer = ({
  name,
  value,
}) => {
  return (
    <CheckboxInput>
      <input id={`${value}-checkbox`} aria-labelledby={`${value}-checkbox`} name={name} value={value} type="checkbox" />
      <CheckIcon />
      <Typography.Body >{value}</Typography.Body>
    </CheckboxInput>
  );
};

const LeadForm = () => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [hasError, setError] = useState(false);
  const [isNameValid, setIsNameValid] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const location = useLocation();

  const formRef = useRef(null);

  const handleOnSubmit = (e) => {    
    e.preventDefault();

    if(!isNameValid || !isEmailValid) {
      const formElements = formRef.current.elements;
      formElements.forEach(element => {
        if (element.nodeName === "INPUT" && (element.type === "email" || element.type === "text"))
        {
          element.focus();
          element.blur();
        }
      });
      return false;
    }

    const fields = [...(e.target.elements)].filter(item => item.type !== 'submit');
    
    const br = "\t\r\n";
    const subject = "Toyota IP Solutions Contact Form";
    const categories = fields.filter(item => item.type === 'checkbox' && item.checked).map(item => `- ${item.value}${br}`).join('');
    const otherInputs = fields.filter(item => item.type !== 'checkbox');
    const contactInfo = {};

    for (var i = 0; i < otherInputs.length; i++){
      contactInfo[otherInputs[i].name] = otherInputs[i].value;
    }

    var emailBody = `Name: ${contactInfo.name} ${br}Email: ${contactInfo.email} ${br}Title: ${contactInfo.title} ${br}Company: ${contactInfo.company} ${br}Categories of interest: ${categories} ${br}Message: ${contactInfo.message}`
    
    const URL = (window.location.hostname === 'www.toyotaipsolutions.com' || window.location.hostname === 'd2vj7fsep4ukgx.cloudfront.net') ? configData.formEndpoints.prd : configData.formEndpoints.qa;
    const data = { 
      "subject": subject, 
      "emailBody": emailBody, 
    }

    axios({
      method: 'post',
      url: URL,
      data: data,
      responseType: 'json'
    })
    .then((response) => {
      if (response.status === 200){
        setError(false)
        // track succesful submit
        const gaGroup = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';

        let routerCategory;

        if (location.pathname == "/") {
          routerCategory = 'home'
        }else {
          routerCategory = location.pathname.replace(/portfolios/g, '').replace(/\//g, '');
        }

        if (window.gtag) {
          if(typeof window.contactSource === "undefined"){
            window.contactSource = {
              category: routerCategory,
              label: `${gaGroup}:contact:submission`
            }
          }
          window.gtag('event', 'submission', { 'event_category': `${window.contactSource.category}`, 'event_label': `${window.contactSource.label}`, 'send_to': gaGroup });
        }
      } else {
        setError(true)
      }
      setOpenModal(!openModal)
    })
    .catch((err) => {
      setError(true)
      setOpenModal(!openModal)
    })
  };

  return (
    <Wrapper>
      <Intro id="contact">
        <FadeIn up>
          <Typography.Heading3>{t('FormData.heading')}</Typography.Heading3>
          <Typography.Body><HtmlText>{t('FormData.description')}</HtmlText></Typography.Body>
        </FadeIn>
      </Intro>
      <ModalProvider>
        {openModal && <ConfirmationModal hasError={hasError} success={openModal} />}
      </ModalProvider>
      <form method="POST" ref={formRef} onSubmit={handleOnSubmit}>
        <FadeIn up delay={250}>
          <OptionsHeading>{t('FormData.optionsHeading')}</OptionsHeading>
          <OptionsInstructions><HtmlText>{t('FormData.optionsInstructions')}</HtmlText></OptionsInstructions>
          <Checkboxes>
            {
              t('FormData.checkboxValues', { returnObjects: true }).map(value => <CheckboxInputContainer key={value} name="categories" value={value} />)
            }
          </Checkboxes>
          {
            t('FormData.inputPlaceholders', { returnObjects: true }).map(input => <TextInput key={input.name} setIsNameValid={setIsNameValid} setIsEmailValid={setIsEmailValid} name={input.name} placeholder={input.placeholder} />)
          }
          <MessageArea />
          <CtaWrapper>
            <ToyotaButton>
              <Typography.BodyBold>{t('FormData.buttonContent')}</Typography.BodyBold>
            </ToyotaButton>
          </CtaWrapper>
        </FadeIn>
      </form>
    </Wrapper>
  );
};

export default LeadForm;
